var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { FieldWrapper, InputDateRangePicker, } from '@dixa/lib-shared-habla';
import moment from 'moment-timezone';
import { useHookFormFieldWrapper, } from 'utils/hookForm';
/**
 * Represents the React Hook Form variant of the {@link InputDateRangePicker}
 * component.
 */
export const HookFormDateRangePicker = (props) => {
    var _a, _b;
    const _c = useHookFormFieldWrapper(props), _d = _c.controller.field, { onBlur, value: fieldValue } = _d, field = __rest(_d, ["onBlur", "value"]), { controllerProps: { name }, fieldWrapperProps } = _c;
    const value = fieldValue;
    /** Handles the date selection. */
    const handleChange = (value) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        (_b = (_a = props.componentProps) === null || _a === void 0 ? void 0 : _a.onChange) === null || _b === void 0 ? void 0 : _b.call(_a, value);
        (_c = field.onChange) === null || _c === void 0 ? void 0 : _c.call(field, {
            startDate: (_e = (_d = value.startDate) === null || _d === void 0 ? void 0 : _d.toISOString()) !== null && _e !== void 0 ? _e : '',
            localStartDate: (_g = (_f = value.localStartDate) === null || _f === void 0 ? void 0 : _f.toISOString()) !== null && _g !== void 0 ? _g : '',
            endDate: (_j = (_h = value.endDate) === null || _h === void 0 ? void 0 : _h.toISOString()) !== null && _j !== void 0 ? _j : '',
            localEndDate: (_l = (_k = value.localEndDate) === null || _k === void 0 ? void 0 : _k.toISOString()) !== null && _l !== void 0 ? _l : '',
            timezone: (_m = value === null || value === void 0 ? void 0 : value.timezone) !== null && _m !== void 0 ? _m : '',
            localTimezone: (_o = value === null || value === void 0 ? void 0 : value.localTimezone) !== null && _o !== void 0 ? _o : '',
        });
    };
    return (_jsx(FieldWrapper, Object.assign({}, fieldWrapperProps, { children: _jsx(InputDateRangePicker, Object.assign({}, props.componentProps, field, { name: name, onChange: handleChange, value: {
                startDate: moment(value === null || value === void 0 ? void 0 : value.localStartDate, moment.ISO_8601).isValid()
                    ? moment(value.localStartDate, moment.ISO_8601)
                    : null,
                endDate: moment(value === null || value === void 0 ? void 0 : value.localEndDate, moment.ISO_8601).isValid()
                    ? moment(value.localEndDate, moment.ISO_8601)
                    : null,
            }, timezone: value === null || value === void 0 ? void 0 : value.timezone, "aria-disabled": fieldWrapperProps.disabled, disabled: fieldWrapperProps.disabled, "aria-required": fieldWrapperProps.required, required: fieldWrapperProps.required, dropdownProps: Object.assign(Object.assign({}, ((_b = (_a = props.componentProps) === null || _a === void 0 ? void 0 : _a.dropdownProps) !== null && _b !== void 0 ? _b : {})), { onClose: onBlur }) })) })));
};
